export const linkedToOptions = [{value: 'checklist', label: 'Checklist'}, {value: 'document', label: 'Document'}];
